// ----------------------------------------------------------------------

const account = {
  displayName: localStorage.getItem("name"),
  role:localStorage.getItem("role") ,
  photoURL: '/static/mock-images/avatars/avatar_default.jpg',
};

export default account;
